import React, { useContext } from "react";
import { Box, Typography, Paper, styled, useTheme } from "@mui/material";
import { Contact, Innucation, TextSizes } from "entities/constants";
import { TextSizeContext } from "data/index";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  padding: "2rem",
  [theme.breakpoints.down("sm")]: {
    padding: "1.5rem 1rem",
  },
}));

const Card = styled(Paper)(({ theme }) => ({
  padding: "2rem",
  borderRadius: "16px",
  boxShadow: theme.shadows[2],
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
}));

const Header = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "1.4rem",
  color: theme.palette.text.primary,
}));

const Paragraph = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.8,
}));

const ContactusTab = () => {
  const { state: textSize } = useContext(TextSizeContext);
  const theme = useTheme();

  return (
    <Container>
      <Card>
        <Header>INNUCATION</Header>
        <Paragraph fontSize={TextSizes[textSize].body}>
          {Innucation}
        </Paragraph>
      </Card>

      <Card>
        <Header>{`Contact`}</Header>
        <Paragraph fontSize={TextSizes[textSize].body}>
          {Contact}
        </Paragraph>
      </Card>
    </Container>
  );
};

export default ContactusTab;
